import { capitalize, startCase } from 'lodash';

import staticText from '../../../../../../localization/Application/Configuration/vehicleAccess';

// eslint-disable-next-line import/prefer-default-export
export const getChipContent = (signal) => {
  return staticText.userFriendlyScopeMap[signal.permission]
    || capitalize(startCase(signal.permission));
};

export const getInitialVehicleAccessSelections = (publishedVehicleAccess, signals) => {
  const publishedVehicleAccessSelections = {
    signals: [],
    attributes: [],
    commands: [],
  };

  publishedVehicleAccess.forEach((name) => {
    const [groupName, keyName] = name.split('.');
    if (groupName === 'Commands') {
      publishedVehicleAccessSelections.commands.push(name);
    } else {
      const signalGroup = signals.signalsByGroup[groupName];
      const signalObj = signalGroup.find((signal) => {
        return signal.name === keyName;
      });
      if (signalObj) {
        if (signalObj.type === 'signal') {
          publishedVehicleAccessSelections.signals.push(name);
        } else if (signalObj.type === 'attribute') {
          publishedVehicleAccessSelections.attributes.push(name);
        }
      }
    }
  });

  return publishedVehicleAccessSelections;
};
